import React from 'react';
import PropTypes from 'prop-types';
import IncidentNodeSelectorField from './IncidentNodeSelectorField';

const IncidentNodeSelectorDynamicField = ({
  input,
  nodes,
  nodePathsPerRow,
  callbackRef,
  allowDuplicateNodes,
  label = "Tipo de incidencia",
}) => {
  const onNodePathChange = callbackRef ? callbackRef.onNodePathChange : null;

  const fieldPrefix = input.name.replace(/\.nodeSelector$/, '');

  const handlePathChange = (newPath) => {
    if (onNodePathChange) onNodePathChange(input.name, newPath);
  };

  const usedNodeIds = Object.keys(nodePathsPerRow)
    .filter((fieldName) => fieldName !== input.name)
    .map((fieldName) => {
      const path = nodePathsPerRow[fieldName];
      return path && path.length > 0 ? path[0].id : null;
    })
    .filter((id) => id !== null);

  // const availableNodes = nodes.filter(
  //   (node) => usedNodeIds.indexOf(node.id) === -1,
  // );

  const availableNodes = allowDuplicateNodes
    ? nodes
    : nodes.filter((node) => usedNodeIds.indexOf(node.id) === -1);


  const myCurrentPath = nodePathsPerRow[input.name] || [];

  const myRootNodeId = myCurrentPath && myCurrentPath.length > 0
    ? myCurrentPath[0].id
    : null;
    
  const mySelectionWasStolen = myRootNodeId !== null
    && usedNodeIds.indexOf(myRootNodeId) !== -1;

  if (!nodes || nodes.length === 0) return null;

  return (
    <IncidentNodeSelectorField
      key={mySelectionWasStolen ? `${fieldPrefix}-reset` : fieldPrefix}
      nodes={availableNodes}
      fieldPrefix={fieldPrefix}
      onPathChange={handlePathChange}
      initialPath={myCurrentPath}
      label={label}
    />
  );
};

IncidentNodeSelectorDynamicField.propTypes = {
  input: PropTypes.shape({ name: PropTypes.string }).isRequired,
  nodes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      noteRequired: PropTypes.bool,
      children: PropTypes.arrayOf(PropTypes.number),
    })
  ),
  nodePathsPerRow: PropTypes.shape({}).isRequired,
  callbackRef: PropTypes.shape({
    onNodePathChange: PropTypes.func,
  }),
  allowDuplicateNodes: PropTypes.bool,
  label: PropTypes.string,
};

IncidentNodeSelectorDynamicField.defaultProps = {
  nodes: [],
  callbackRef: null,
  allowDuplicateNodes: false,
  label: "Tipo de incidencia",
};
export default IncidentNodeSelectorDynamicField;  